import script from "./sf-dropdown-item-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-dropdown-item-group.vue?vue&type=script&setup=true&lang=ts"

import "./sf-dropdown-item-group.vue?vue&type=style&index=0&id=54b10866&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b10866"]])

export default __exports__